module.exports = [
  {
    "featureType": "water",
    "elementType": "All",
    "stylers": [
      { "color": "#000000" }
    ]
  },{
    "featureType": "landscape",
    "elementType": "All",
    "stylers": [
      { "color": "#2c0900" }
    ]
  },{
    "featureType": "road.highway",
    "elementType": "geometry",
    "stylers": [
      { "color": "#420e01" }
    ]
  },{
    "featureType": "road.arterial",
    "elementType": "geometry",
    "stylers": [
      { "color": "#420e01" }
    ]
  },{
    "featureType": "road.local",
    "elementType": "geometry",
    "stylers": [
      { "color": "#420e01" }
    ]
  },{
    "featureType": "All",
    "elementType": "labels.text.fill",
    "stylers": [
      { "color": "#ffffff" }
    ]
  },{
    "featureType": "All",
    "elementType": "labels.text.stroke",
    "stylers": [
      { "color": "#ffffff" },
      { "weight": 0.3 }
    ]
  },{
    "featureType": "poi",
    "elementType": "geometry",
    "stylers": [
      { "color": "#420e01" }
    ]
  }
]



/*****************
 ** WEBPACK FOOTER
 ** ./dev/js/modules/gmapsStyles.js
 ** module id = 12
 ** module chunks = 1
 **/